import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Modal from '../../usables/Modal'
import Input from '../../usables/small/Input'
import Table from '../../usables/Table'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'

export default function  People() {
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [people, setPeople] = useState([]);
  const [formData, setFormData] = useState({name: '', lastname: '', email:'', phone: ''})
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})

  const tableColumns = [{
    Header: "Asmenys",
    columns: [
      {
        Header: "Vardas",
        accessor: "name"
      },
      {
        Header: "Pavardė",
        accessor: "lastname"
      },
      {
        Header: "Telefonas",
        accessor: "phone"
      },
      {
        Header: "El. paštas",
        accessor: "email"
      },
      {
        Header: "Veiksmai",
        accessor: "action"
      }
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const createPerson = () => {
    axios.post(process.env.REACT_APP_API + '/people', formData, config)
      .then((res)=>{
        if(res.status === 200){
          res.data.person.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/people/' + res.data.person.id}>Daugiau</Link>
          setPeople(people => [res.data.person, ...people ])
        }
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/people', config)
    .then(res => {
      if(res.status === 200){
        //console.log(...res.data)
        setPeople([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          data.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/people/' + data.id}>Daugiau</Link>
          // console.log(data)
          setPeople(people => [...people, data])
          setDataLoaded({done: true, sucssess: true, items: res.data.length})
        })
      }
    })
    .catch(err => {
      setPeople([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setPeople(people => [...people, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <>
    <h2>Asmenys</h2>
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <Table columns={tableColumns} data={people} />
          : <ClosingAlert type='warning' message='Nerasta mokomūjų dalykų' />
        : <ClosingAlert type='error' message='Kažkas nepavyko, bendykite vėl šiek tiek vėliau' />
      }
    {/* <Table columns={tableColumns} data={people} /> */}
    {/* Asmenys: 
    {people.map(person => {
      return <div key={person.id}>{JSON.stringify(person)} <Link className='text-violet-300 hover:text-violet-700' to={'/people/' + person.id}>Daugiau</Link></div>
    })} */}
    {authUser().roles.admin &&
    <Modal showAddBtn={true} title='Naujas asmuo' saveText='Sukurti' submitFunction={() => createPerson()}>
      <div className='pt-5'>
        <Input
          label='Vardas'
          name='name'
          type='text'
          value={formData.name}
          onChange={(e)=>setFormData({...formData, name: e.target.value})}
          />
        <Input
          label='Pavardė'
          name='lastname'
          type='text'
          value={formData.lastname}
          onChange={(e)=>setFormData({...formData, lastname: e.target.value})}
          />
        <Input
          label='El. paštas'
          name='email'
          type='email'
          value={formData.email}
          onChange={(e)=>setFormData({...formData, email: e.target.value})}
          />
        <Input
          label='Telefonas'
          name='phone'
          type='tel'
          value={formData.phone}
          onChange={(e)=>setFormData({...formData, phone: e.target.value})}
          />
        </div>
      </Modal>
}
    </>
  )
}